export function scaleToFit(
    w1: number,
    h1: number,
    w2: number,
    h2: number
): number {
    let scale = w2 / w1;
    if (h1 * scale < h2) {
        scale = h2 / h1;
    }
    return scale;
}
